import React from 'react';
import { Link } from 'react-router-dom';
import MetaData from './layout/MetaData';
import CurrentOrdersHome from './layout/CurrentOrdersHome';
import '../css/Home.css';

import LandingPage from './bs/LandingPage';
import IndustryFreightPage from './bs/IndustryFreightPage';
import PictureHome from './bs/PictureHome';

const bookingTypes = [
  { key: 'local',  label: 'Local',      img: '../images/local.png',  to: '/select-address',      note: 'Within the city' },
  { key: 'import', label: 'Import',     img: '../images/import.png', to: '/under-construnction', note: 'Coming soon' },
  { key: 'export', label: 'Export',     img: '../images/export.png', to: '/under-construnction', note: 'Coming soon' },
];

const Home = () => {
  return (
    <>
      <MetaData title="Transportation Services" />

      {/* Hidden SEO content */}
      <h1 className="para-seo-home">MBZ Transport, Transportation Services</h1>
      <h1 className="para-seo-home">One Stop Solution for all your transportation needs</h1>
      <h1 className="para-seo-home">Address: B-26, Basement, Block-15, Gulshan-E-Iqbal, Karachi-Pakistan</h1>

      <LandingPage />

      <CurrentOrdersHome />

      <section className="booking-section">
        <h2 id="product_heading">Select a Type of Booking</h2>
        <div id="all-select-options-home">
          {bookingTypes.map((b) => (
            <div className="booking-select-div" key={b.key} id={b.key === 'import' ? 'import-home-select' : undefined}>
              <Link to={b.to} className="booking-type-link">
                <img src={b.img} alt={b.label} className="booking-select-Link" />
              </Link>
            </div>
          ))}
        </div>
      </section>

      <IndustryFreightPage />
      <PictureHome />
    </>
  );
};

export default Home;
